import defaultCatalog from '@/content/public-help-catalog.json';

export type PublicHelpCatalog = typeof defaultCatalog;
export type PublicGuide = PublicHelpCatalog['guides'][number];

/** One catalog reader for Help and workspace search; article bodies stay in Help Center. */
export function parsePublicHelpCatalog(data: unknown): PublicHelpCatalog {
  if (!data || typeof data !== 'object') throw new Error('Guide catalog unavailable');
  const value = data as Record<string, unknown>;
  if (!Array.isArray(value.guides) || !Array.isArray(value.categories))
    throw new Error('Invalid guide catalog');
  const guides = value.guides.filter(
    (g): g is PublicGuide =>
      g &&
      typeof g === 'object' &&
      typeof g.id === 'string' &&
      /^[a-z0-9-]+$/.test(g.id) &&
      typeof g.title === 'string' &&
      typeof g.description === 'string' &&
      typeof g.category === 'string' &&
      typeof g.minutes === 'number' &&
      typeof g.keywords === 'string',
  );
  const categories = value.categories.filter(
    (c): c is PublicHelpCatalog['categories'][number] =>
      c &&
      typeof c === 'object' &&
      typeof c.id === 'string' &&
      typeof c.title === 'string' &&
      typeof c.description === 'string' &&
      typeof c.icon === 'string',
  );
  if (!guides.length || !categories.length) throw new Error('Empty guide catalog');
  return { guides, categories };
}
export const publicGuideHref = (origin: string, id: string) => `${origin}/${encodeURIComponent(id)}/`;
export { defaultCatalog };
